import PropTypes from 'prop-types';

const propType = {
  portal: PropTypes.string,
  store: PropTypes.string,
  userPortal: PropTypes.string,
  academy: PropTypes.string,
  marketPlace: PropTypes.string,
  googleApp: PropTypes.string,
  appleApp: PropTypes.string,
  facebookAppId: PropTypes.string,
};

export default { propType };
